// screens/staff/PeriodToggle.tsx
//
// W6 v1.1 — extracted from MetricheScreen for reuse on ClassPulseScreen.
//
// Pill-style 7gg / 30gg / 90gg toggle with `aria-pressed` + tokens-driven
// styling. Matches the W6 v1 Session 3 visual + behavioral spec verbatim.

import { type JSX } from 'react';
import { useTokens } from '../../state/theme';

export type Period = 7 | 30 | 90;

interface PeriodToggleProps {
  /** Currently selected period in days. */
  value:    Period;
  onChange: (next: Period) => void;
  /** Optional aria-label override. Default: "Periodo di riferimento". */
  ariaLabel?: string;
  /** Optional data-testid prefix for the buttons. Default: 'period'. Each
   *  button gets data-testid = `${prefix}-${period}`. */
  testidPrefix?: string;
}

const OPTIONS: ReadonlyArray<Period> = [7, 30, 90];

export default function PeriodToggle({
  value,
  onChange,
  ariaLabel = 'Periodo di riferimento',
  testidPrefix = 'period',
}: PeriodToggleProps): JSX.Element {
  const tokens = useTokens();
  return (
    <div role="group" aria-label={ariaLabel} style={{ display: 'flex', gap: 8 }}>
      {OPTIONS.map((p) => (
        <button
          key={p}
          data-testid={`${testidPrefix}-${p}`}
          onClick={() => onChange(p)}
          aria-pressed={value === p}
          style={{
            background:    value === p ? tokens.accentSoft : 'transparent',
            color:         value === p ? tokens.accentInk  : tokens.text,
            border:        `1px solid ${tokens.line}`,
            borderRadius:  tokens.radius.pill,
            padding:       '8px 16px',
            cursor:        'pointer',
            fontSize:      13,
            fontWeight:    value === p ? 600 : 500,
            fontFamily:    tokens.fonts.body,
          }}
        >
          {p}gg
        </button>
      ))}
    </div>
  );
}
